import Icon from './icon.txt';

export default {
    render (h) {
        return h('span', {
            class: 'file-plus-icon',
            domProps: {
                innerHTML: Icon,
            }
        })
    }
}
